import React from 'react';

const AboutUs = () => {
    return (
        <div classname="about-container">
            <h3>Want to about us?</h3>
            <p>"About Us" page is a great place for it to live, too. Good stories humanize your brand, providing context and meaning for your product.</p>
            <img className="about-img w-100" src="https://cdn.shopify.com/s/files/1/0070/7032/files/how-to-write-an-about-us-wip1.png?format=jpg&quality=90&v=1618511825" alt="" />

        </div>
    );
};

export default AboutUs;